module.exports = __webpack_public_path__ + "img/speaker-ClarenceSeedorf-imgs.8371b009.png";